import React from "react";
// import { Done, DoneAll } from "@mui/icons-material";
import AudioPlayer from "react-h5-audio-player";
// import ReplyIcon from "@mui/icons-material/Reply";
// import DeleteIcon from "@mui/icons-material/Delete";
import classes from "./audienceVoiceMessage.module.scss";

const AudienceVoiceMessage = ({
  chat,
  //   userId,
  //   reply,
  //   deleteMessage,
  doc,
  imgSrc,
}) => {
  //   const owner = parseInt(userId) === parseInt(chat.user_id);

  return (
    <div key={chat.key} className={classes.mainContainer}>
      <div className={classes.messageContainer}>
        <span>
          <div>
            <AudioPlayer
              preload="none"
              src={chat.file}
              showSkipControls={false}
              showJumpControls={false}
              customVolumeControls={[]}
              customAdditionalControls={[]}
              // other props here
            />
          </div>

          {/*<audio preload='none' src={chat.file} controls />*/}
        </span>
        {doc}
        {/* <p>{chat.message}</p> */}
      </div>
      <img className={classes.userImg} src={imgSrc} alt="userImg" />

      <time>{chat.created_at}</time>
      {/* {owner ? (
          <span className="seen">{chat.seen ? <DoneAll /> : <Done />}</span>
        ) : null} */}
      {/* {owner ? (
        <div className="control_message" style={{ display: "inline-block" }}>
          <ReplyIcon
            className="reply_message"
            style={owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }}
            onClick={() => reply(chat)}
          />
          <DeleteIcon
            className="delete_message"
            onClick={() => deleteMessage(chat)}
          />
        </div>
      ) : (
        <div  >
          <ReplyIcon
            className="reply_message"
            style={owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }}
            onClick={() => reply(chat)}
          />
        </div>
      )} */}
    </div>
  );
};

export default AudienceVoiceMessage;
